<p-card styleClass="!bg-primary-100 p-6 w-52 h-52">
  <div class="flex flex-col items-center justify-center">
    <img
      [style]="
        'filter: brightness(0) saturate(100%) invert(47%) sepia(51%) saturate(525%) hue-rotate(131deg) brightness(96%) contrast(93%)'
      "
      [src]="item.icon"
      alt="icon"
      class="h-20 w-20"
    />
    <div class="mt-2 text-center text-sm text-alt-primary-100">
      {{ item.data }} {{ item.label | transloco }}
    </div>
  </div>
</p-card>
